import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { TrSuitabilityQuestionMultipleAnswersComponent } from './tr-suitability-question-multiple-answers/tr-suitability-question-multiple-answers.component';
import { TrSuitabilityQuestionSelectAnswerComponent } from './tr-suitability-question-select-answer/tr-suitability-question-select-answer.component';
import { TrSuitabilityQuestionUniqueAnswerComponent } from './tr-suitability-question-unique-answer/tr-suitability-question-unique-answer.component';
import { TrInputsModule } from '../tr-forms-inputs/tr-forms-inputs.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TrCheckboxModule } from '../tr-forms-inputs/tr-checkbox/tr-checkbox.module';
import { SuitabilityPipeModule } from '../../pipes/suitability/suitability.module';
import { ArraySortPipeModule } from '../../pipes/array-sort/array-sort.module';

@NgModule({
    imports: [
        CommonModule,
        TrInputsModule,
        MatSelectModule,
        MatOptionModule,
        ArraySortPipeModule,
        ReactiveFormsModule,
        TrCheckboxModule,
        SuitabilityPipeModule,
    ],
    declarations: [
        TrSuitabilityQuestionMultipleAnswersComponent,
        TrSuitabilityQuestionSelectAnswerComponent,
        TrSuitabilityQuestionUniqueAnswerComponent,
    ],
    exports: [
        TrSuitabilityQuestionMultipleAnswersComponent,
        TrSuitabilityQuestionSelectAnswerComponent,
        TrSuitabilityQuestionUniqueAnswerComponent,
    ],
})
export class TrSuitabilityQuestionsModule {}
